import * as tradeInVehicleTypes from 'commons-vehicle/Vehicle/actions/tradeInVehicleActionTypes.js';

import TradeInVehicleAPIService from 'commons-vehicle/Vehicle/services/TradeInVehicleAPIService/TradeInVehicleAPIService.js';
import * as TradeInVehicleService from 'commons-vehicle/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js';
import PurchaseMethodsModel from 'commons-vehicle/PurchaseMethods/models/PurchaseMethodsModel.js';
import * as PurchaseMethodsActions from 'commons-vehicle/PurchaseMethods/actions/purchaseMethodsActions.js';

import { WindowProxy } from '@sm360/widget-commons-core-services';
import { EVENTS } from '@sm360/widget-commons-general';

import { UPDATE_STATUS } from 'commons-vehicle/Vehicle/constants/tradeInVehicleStatuses.js';

export function setTradeInVehicle(tradeInVehicle) {
    return { type: tradeInVehicleTypes.SET_TRADE_IN_VEHICLE, tradeInVehicle };
}

export function saveTradeInVehicle(tradeInVehicle) {
    return (dispatch) => {
        TradeInVehicleAPIService.saveTradeInVehicle(tradeInVehicle).then(() => {
            const $window = WindowProxy.get();
            if ($window) {
                $window.document.dispatchEvent(new CustomEvent(EVENTS.TRADEIN_CREATED));
            }
            dispatch(setTradeInVehicle(tradeInVehicle.set('modified', false)));
        });
    };
}

export function setTradeInTaxCreditDetails(tradeInTaxCreditDetails) {
    return { type: tradeInVehicleTypes.SET_TRADE_IN_TAX_CREDIT_DETAILS, tradeInTaxCreditDetails };
}

export function loadTradeInVehicle(stateTradeInVehicle, tradeInVehicleId) {
    return (dispatch) => {
        return TradeInVehicleAPIService.loadTradeInVehicle(tradeInVehicleId).then((tradeInVehicle) => {
            const isEmptyTradeIn = !stateTradeInVehicle.id;
            let newTradeInVehicle = tradeInVehicle;
            const defaultPurchaseMethods = new PurchaseMethodsModel();
            const stateTradeInAmount = isEmptyTradeIn
                ? defaultPurchaseMethods.tradeIn
                : stateTradeInVehicle.getTradeInAmount();
            const stateLienAmount = isEmptyTradeIn ? defaultPurchaseMethods.lien : stateTradeInVehicle.getLienAmount();
            const loadedTradeInAmount = tradeInVehicle.getTradeInAmount();
            const loadedLienAmount = tradeInVehicle.getLienAmount();
            const isActivatedTradeIn = newTradeInVehicle.getUpdateStatus() === UPDATE_STATUS.ACTIVATED;
            const isDescribedTradeIn = newTradeInVehicle.getUpdateStatus() === UPDATE_STATUS.DESCRIBED;

            if (stateTradeInAmount !== loadedTradeInAmount || stateLienAmount !== loadedLienAmount) {
                if (stateTradeInAmount > 0 && (isActivatedTradeIn || isDescribedTradeIn)) {
                    newTradeInVehicle = TradeInVehicleService.setTradeIn(newTradeInVehicle, stateTradeInAmount);
                    newTradeInVehicle = TradeInVehicleService.setLien(newTradeInVehicle, stateLienAmount);
                    if (isEmptyTradeIn) {
                        dispatch(PurchaseMethodsActions.setTradeIn(stateTradeInAmount));
                        dispatch(PurchaseMethodsActions.setLien(stateLienAmount));
                    }
                } else {
                    dispatch(PurchaseMethodsActions.setTradeIn(newTradeInVehicle.getTradeInAmount()));
                    dispatch(PurchaseMethodsActions.setLien(newTradeInVehicle.getLienAmount()));
                }
            } else if (
                isEmptyTradeIn &&
                isActivatedTradeIn &&
                !stateTradeInAmount &&
                !loadedTradeInAmount &&
                !stateLienAmount &&
                !loadedLienAmount
            ) {
                newTradeInVehicle = TradeInVehicleService.setTradeIn(newTradeInVehicle, 0);
                newTradeInVehicle = TradeInVehicleService.setLien(newTradeInVehicle, 0);
                dispatch(PurchaseMethodsActions.setTradeIn(0));
                dispatch(PurchaseMethodsActions.setLien(0));
            }

            dispatch(setTradeInVehicle(newTradeInVehicle));
            if (newTradeInVehicle.id && newTradeInVehicle.modified) {
                dispatch(saveTradeInVehicle(newTradeInVehicle));
            }
        });
    };
}

export default {
    setTradeInVehicle,
    saveTradeInVehicle,
    loadTradeInVehicle,
    setTradeInTaxCreditDetails,
};
